import { AutoMap } from "@automapper/classes";

export class AppareilEntity {
    @AutoMap()
    Id?: number;
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Type?: number
    @AutoMap()
    Marque?: number
    @AutoMap()
    Modele?: number
    @AutoMap()
    NumeroInterne: string = ''
}